/* Slides & PDF: deck editor (OFFICE-02) with motion manifests (MEDIA-11) at /slides, and the PDF
   viewer and tools (OFFICE-04) at /slides/pdf. The descriptor has one route per feature, so PDF is
   the second tab of this feature and has its own palette commands. */
import { lazy } from 'react';
import { Presentation } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'slides',
  title: 'Slides & PDF',
  short: 'Slides',
  icon: Presentation,
  group: 'Apps',
  route: '/slides',
  order: 40,
  screen: lazy(() => import('./Screen.tsx')),
  capabilities: ['OFFICE-02', 'OFFICE-04', 'MEDIA-11'],
  commands: [
    { id: 'generate', title: 'Generate a slide deck', to: '/slides?generate=1', keywords: ['slides', 'deck', 'presentation', 'pptx'] },
    { id: 'present', title: 'Present the current deck', to: '/slides?present=1', keywords: ['slides', 'present', 'speaker notes'] },
    { id: 'pdf', title: 'Open PDF tools', to: '/slides/pdf', keywords: ['pdf', 'redact', 'sign', 'merge', 'split', 'compare', 'fill form'] },
  ],
});
